import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { PropsWithChildren } from 'react'

import { getEnvironmentMode } from 'utils/env'

export const ENDPOINT: string = import.meta.env.VITE_API
const queryClient = new QueryClient()

export const TanstackQueryProvider = ({ children }: PropsWithChildren) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}

      {getEnvironmentMode() === 'development' && <ReactQueryDevtools />}
    </QueryClientProvider>
  )
}
